




















import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class shouquan extends Vue {
  // @Prop({}) selectMsg!: any;

  mounted() {}
  // 微信授权
  wxShouquan() {
    var ua: any = navigator.userAgent.toLowerCase(); //获取判断用的对象
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      //在微信中打开
      /*微信登录*/
      var gourl = encodeURIComponent(window.location.href);
      var reduri = "http://reg.chexun.com/weChatScanLogin.aspx?gourl=" + gourl;
      var threeHref =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx9fb7f19e29f57706&scope=snsapi_userinfo&";
      threeHref +=
        "redirect_uri=" +
        reduri +
        "&state=100201&response_type=code#wechat_redirect";
      window.location.href = threeHref;
    }
  }
}
